import { getClassificationsAffiliateLinks } from "../api";
import { affiliateLinkDetailsKeys } from "./keys";
import { useAffiliateLinkDetailQuery } from "./use-affiliate-link-detail-query";

export const useAffiliateLinkClassificationsQuery = (id, enabled = true) =>
  useAffiliateLinkDetailQuery({
    queryKey: affiliateLinkDetailsKeys.classifications(id),
    fetcher: getClassificationsAffiliateLinks,
    id,
    dataKey: "affiliateLinksWithClassification",
    enabled,
  });
